import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const useEquityFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    compensationOffersEquity: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ compensationOffersEquity }) => {
    setFilters(
      { compensationOffersEquity: compensationOffersEquity.value || 'any' },
      {
        removeFilters: compensationOffersEquity.value === 'any' ? ['compensationOffersEquity'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
  };
};

useEquityFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
